import { Box, Button, Typography } from "@mui/material";
import React from "react";
import bannerImage from "../../assets/bannerImage.png";

const Banner = () => {
  return (
    <Box
      sx={{
        // mx: { xs: "16px", sm: "24px", md: "7%", xl: "auto" },
        mt: { xs: "1rem", sm: "1rem", md: "5rem", xl: "128px" },
        p: { xs: "1rem", sm: "32px", md: "50px", xl: "58px 136px" },
        bgcolor: "#213F4B",
        borderRadius: { xs: "16px", sm: "20px", xl: "34px" },
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        // alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: "24px", md: "0" },
        // minHeight: { xs: "auto", md: "327px" },
        maxWidth: "1660px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          borderRight: { xs: "none", md: "1px solid white" },
          borderBottom: { xs: "1px solid white", md: "none" },
          pr: { xs: "0", sm: "20px", md: "25px", xl: "50px" },
          pb: { xs: "24px", md: "0" },
          width: "100%",
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            color: "white",
            fontSize: { xs: "20px", sm: "24px", md: "28px", xl: "36px" },
            fontWeight: 400,
            lineHeight: { xs: "28px", sm: "32px", md: "40px", xl: "57.42px" },
            fontFamily: "DM Serif Text",
          }}
        >
          Didn't Find What You're Looking For?
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "white",
            fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.9rem", xl: "1rem" },
            fontWeight: 400,
            lineHeight: { xs: "20px", sm: "24px", md: "26px", xl: "28.8px" },
            mt: { xs: "8px", sm: "10px", md: "11px" },
            maxWidth: { xs: "100%", md: "90%" },
          }}
        >
          Create a job alert and get notified as soon as new opportunities match
          your criteria.
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            mt: "16px",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "#2A9D8F",
              color: "white",
              textTransform: "none",
              px: "16px",
              borderRadius: "8px",
              ":hover": { backgroundColor: "#21867A" },
            }}
          >
            Create Job Alert
          </Button> */}
          {/* <Button
            variant="contained"
            sx={{
              backgroundColor: "#E9C46A",
              color: "#213F4B",
              textTransform: "none",
              px: "16px",
              borderRadius: "8px",
              ":hover": { backgroundColor: "#D4AE63" },
            }}
          >
            Post Job Now
          </Button> */}
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          width: "100%",
        }}
      >
        <Box
          component="img"
          src={'https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2025/08/bannerImage.png'}
          alt="banner-image"
          sx={{
            maxWidth: "100%",
            height: "auto",
            borderRadius: "16px",
            mt: { md: "-10rem", xl: "-12rem" },
          }}
        />
      </Box>
    </Box>
  );
};

export default Banner;
